<template>
  <el-container class="box">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <div class="top-tabs">
        <div :class="activeName1 == 1 ? 'tabs-cliked' : ''" @click="handleTabClick(1)">
          <span>基本信息</span>
        </div>

        <div :class="activeName1 == 3 ? 'tabs-cliked' : ''" @click="handleTabClick(3)">
          <span>服务管理</span>
        </div>

        <div :class="activeName1 == 4 ? 'tabs-cliked' : ''" @click="handleTabClick(4)">
          <span>小程序分享</span>
        </div>
      </div>
    </div>
    <el-main class="content">
      <template v-if="activeName1 == 1">
        <div class="line-div">
          <span></span>
          <span>
            基本信息
          </span>
        </div>
        <template v-if="isEdit1">
          <el-form ref="addedParamData" @submit.native.prevent :model="addedParamData" label-width="120px"
            :rules="rules">
            <el-form-item label="团队头像：" :rules="[
                { required: true, message: '请上传团队头像', trigger: 'change' }
              ]" required prop="avatarImageUrl">
              <BaseUploadFile :fileSize="6" :isShowTip="false" :size="200" :height="180" :responseFn="handleResponse"
                :action="VUE_APP_BASE_URL" message="* 团队头像大小为200 * 180" :data="{ path: 'dsicm-doctor' }"
                v-model="addedParamData.avatarImageUrl">
              </BaseUploadFile>
            </el-form-item>
            <el-row style="margin: 8px 0;">
              <el-col :span="12">
                <el-form-item label="团队背景图：" :rules="[
                    {
                      required: true,
                      message: '请上传团队背景图',
                      trigger: 'change'
                    }
                  ]" prop="backgroundImageUrl">
                  <BaseUploadFile :fileSize="6" :isShowTip="false" :size="60" :responseFn="handleBackgroundResponse"
                    :action="VUE_APP_BASE_URL" :data="{ path: 'dsicm-doctor' }"
                    v-model="addedParamData.backgroundImageUrl">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="团队名称: " prop="name">
                  <el-input v-model.trim="addedParamData.name" placeholder="请输入团队名称" maxlength="12">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="个案组: " prop="caseMgrGroupId">
                  <!-- 个案组 -->
                  <el-select :disabled="userId" v-model="addedParamData.caseMgrGroupId" @change="caseMgrGroupChange"
                    placeholder="请输入关键词模糊搜索个案组" filterable>
                    <el-option v-for="item in treeListHos" :key="item.id" :label="item.reGroupName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="团队擅长: " prop="professional">
              <el-input type="textarea" class="resizeNone" v-model="addedParamData.professional" placeholder="请输入团队擅长"
                maxlength="200">
              </el-input>
            </el-form-item>
            <el-form-item label="团队介绍: " prop="introduction">
              <el-input type="textarea" class="resizeNone" v-model.trim="addedParamData.introduction"
                placeholder="请输入团队介绍" maxlength="200">
              </el-input>
            </el-form-item>

          </el-form>

        </template>
        <template v-else>
          <el-form ref="addedParamData" @submit.native.prevent :model="addedParamData" label-width="100px">
            <el-form-item label="团队头像: " size="mini">
              <el-image style="width: 200px; height: 180px;margin-right:10px" :src="addedParamData.avatarImageUrl"
                :z-index="2003">
                <div slot="error" class="image-slot">
                  <img src="@/assets/images/noImage.png">
                </div>
              </el-image>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="团队背景图: ">
                  <el-image style="width: 150px; height: 150px;margin-right:10px"
                    :src="addedParamData.backgroundImageUrl" :z-index="2003">
                    <div slot="error" class="image-slot">
                      <img src="@/assets/images/noImage.png">
                    </div>
                  </el-image>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="团队名称：" prop="titleId">
                  <span>{{addedParamData.name|filterValgang}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="个案组：" prop="hospitalId">
                  <span>{{addedParamData.caseMgrGroupName ? addedParamData.caseMgrGroupName : '--'}}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="团队擅长: " prop="professional">
              <span>{{addedParamData.professional ? addedParamData.professional : '--'}}</span>
            </el-form-item>
            <el-form-item label="团队介绍: " prop="introduction">
              <span>{{addedParamData.introduction?addedParamData.introduction:'--'}}</span>
            </el-form-item>
          </el-form>
        </template>
        <span class="dialog-footer" v-if="!isEdit1">
          <el-button size="small" type="primary" @click="detailEdit">编辑</el-button>
        </span>
        <span class="dialog-footer" v-if="isEdit1">
          <!-- <el-button size="small" @click="closeaddCare()">重置</el-button> -->
          <el-button size="small" type="primary" @click="submiAddCare5('addedParamData')">保存</el-button>
        </span>
      </template>

      <template v-if="activeName1 == 3" class="info-upload">
        <div class="line-div">
          <span></span>
          <span>
            服务管理
          </span>
          <el-button type="primary" v-if="isEdit3" size="small" @click="serviceOpen">新增服务</el-button>
        </div>

        <template>
          <el-table :header-cell-style="styleObj" :data="teamServiceList" style="width: 100%">
            <el-table-column type="index" label="序号">
              <template slot-scope="scope">
                {{ scope.$index * 1 + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="疗管链名称">
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="主适配病种">
              <template slot-scope="scope">
                {{ scope.row.diseaseType }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="开启体验">
              <template slot-scope="scope">
                {{ scope.row.experiencePack == true ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="公共领取">
              <template slot-scope="scope">
                {{ scope.row.commonStatus == true ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column label="服务周期">
              <template slot-scope="scope">
                {{ scope.row.period + "" + scope.row.periodType }}
              </template>
            </el-table-column>
            <el-table-column prop="edit" label="服务价格现价（元）">
              <template slot-scope="scope">
                <span v-if="!scope.row.edit">{{ scope.row.price }}</span>
                <el-input type="text" v-if="scope.row.edit" clearable v-model="scope.row.price">
                </el-input>
                <!-- <el-input-number style="width: 130px;" v-if="scope.row.edit" v-model="scope.row.price"
                        :controls="false"></el-input-number> -->
              </template>
            </el-table-column>
            <el-table-column prop="edit" label="原价（元）">
              <template slot-scope="scope">
                <span v-if="!scope.row.edit">{{
                  scope.row.originalPrice
                }}</span>
                <el-input type="text" v-if="scope.row.edit" clearable v-model="scope.row.originalPrice">
                </el-input>
                <!-- <el-input-number style="width: 130px;" v-if="scope.row.edit" v-model="scope.row.originalPrice"
                        :controls="false"></el-input-number> -->
              </template>
            </el-table-column>

            <!-- 医生服务为付费类型时展示前端展示 -->
            <el-table-column prop="patientShow" label="前端展示">
              <template slot-scope="scope">
                <span v-if="scope.row.experiencePack !== true"
                  :style="`color:#fff;padding:7px;border-radius:2px;background:${scope.row.patientShow === true ? '#0CB79F' : scope.row.patientShow === false ? '#FCB023' : ''}`">{{ scope.row.patientShow === true ? '是' : scope.row.patientShow === false ? '否' : '' }}</span>
				  <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="180" v-if="isEdit3">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'remove')">移除
                </el-button>
                <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'first')">
                  {{ scope.row.edit ? "保存" : "编辑" }}
                </el-button>
                <!-- <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'second')">
									{{ scope.row.recommend ? "取消推荐" : "设为推荐" }}
								</el-button> -->

                <!-- 医生服务为付费类型时展示前端展示 -->
                <el-button type="text" size="mini" @click="showFront(scope.row)" :disabled="scope.row.experiencePack == true">
                  {{scope.row.patientShow ? '不展示' : '展示'}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <!-- </template> -->
        <div v-if="serviceListIf" style="margin-top: 40px;">
          <div class="line-div">
            <span></span>
            <span>
              搜索服务
            </span>
          </div>
          <el-form :inline="true" :model="formInline2" class="demo-form-inline">
            <el-form-item>
              <el-input size="small" v-model="formInline2.name" placeholder="请输入疗管链名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="resetHandel2">重置</el-button>
              <el-button size="small" type="primary" @click="formInlineSubmit1">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="list-two">
            <el-table :header-cell-style="styleObj" id="tableInfo" :data="tableData2" style="width: 100%">
              <el-table-column type="index" label="序号">
                <template slot-scope="scope">
                  {{ scope.$index * 1 + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="疗管链名称" align="center">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="主适配病种">
                <template slot-scope="scope">
                  {{ scope.row.diseaseType }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="开启体验">
                <template slot-scope="scope">
                  {{ scope.row.experiencePack == true ? '是' : '否' }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="公共领取">
                <template slot-scope="scope">
                  {{ scope.row.commonStatus == true ? '是' : '否' }}
                </template>
              </el-table-column>
              <el-table-column label="服务周期" align="center">
                <template slot-scope="scope">
                  {{ scope.row.period + scope.row.periodType }}
                </template>
              </el-table-column>
              <el-table-column prop="diseaseType" label="适配病种" align="center"></el-table-column>
              <el-table-column v-if="isEdit3" label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button @click="choisePerson3(scope.row, scope.$index)" type="text" size="small">
                    添加
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination class="pagenation" background @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1" :current-page.sync="formInline2.current"
            :page-size="formInline2.size" layout="total, sizes, prev, pager, next, jumper" :total="formInline2.total">
          </el-pagination>
        </div>
        <span class="dialog-footer" v-if="!isEdit3">
          <el-button size="small" type="primary" @click="isEdit3 = true">编辑</el-button>
        </span>
      </template>
      <div v-if="activeName1==4" :key="400">
        <el-table :data="tableData" :header-cell-style="styleObj">
          <el-table-column prop="diseaseTypeName" label="战略病种" width="100px">
          </el-table-column>
          <el-table-column align="center" prop="publicityText" label="宣传文案" min-width="300px">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.publicityText"
                :disabled="scope.row.publicityText&&scope.row.publicityText.length>6?false:true" placement="top">
                <span class="tooltipWidth">{{ scope.row.publicityText | filterValgang }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="publicityPictureUrl" label="宣传图片" min-width="100px">
            <template slot-scope="scope">
              <img style="width:50px;height:50px" :src="ossBaseUrl+scope.row.publicityPictureUrl" alt="">
            </template>
          </el-table-column>

          <el-table-column prop="updateUserName" label="操作人">
          </el-table-column>

          <el-table-column align="center" fixed="right" width="180" label="操作">
            <template slot-scope="scope">

              <el-button @click="onEditeClick(scope.row)" type="text" size="small">
                编辑
              </el-button>
              <!-- </div> -->
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="600px">
          <el-form :model="formShare" ref="form" label-width="120px" :rules="rules">
            <el-form-item label="战略病种:" prop="diseaseTypeName">
              {{formShare.diseaseTypeName}}
            </el-form-item>
            <el-form-item label="宣传文案:" prop="publicityText">
              <el-input v-model="formShare.publicityText" maxlength="27" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="宣传图片:" prop="publicityPictureUrlRes">
              <BaseUploadFile :multiple="false" :fileSize="6" :isShowTip="false" :cropWidth="100" :cropHeight="100"
                :size="100" :height="100" action="/api/dsicm-contact-platform/feign/file/wechat/upload/app-id"
                :beforeRemove="handleMessagebeforeRemoveShare" :responseFn="handleMessageResponseShare"
                :data="{ path: 'dsicm-doctor',type: 'image',mediaId: formShare.mediaId,appId:formShare.appId  }"
                v-model="formShare.publicityPictureUrlRes">
              </BaseUploadFile>
              <p style="font-size: 10px;font-weight: 400;color: #999999;">*
                请上传至少100*100px的正方形图片，最大1M的png、jpg、jpeg</p>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="editSure">确 定</el-button>
          </div>
        </el-dialog>

      </div>
    </el-main>
  </el-container>
</template>

<script>
import local from "@/utils/local.js";

import {
  openeDpartment,
  setAsLeader,
  setAsMatron, //设置护士长
  treeList,
} from "@/api/doctorTeam.js";
import { plateFormOn } from "@/api/acc.js";
import {
  getCourseManageMediaList,
  getCourseManageMediaDetail,
  updateCourseManageMedia,
  getPlatformList,
  getPlatformDepartmentList,
  getHospitalDepartmentList,
  doctorTeamCreate,
  doctorSearch,
  getCourseManageTeam,
  getAllTherapistScheme,
  AdddoctorMember,
  doctorMemberDelete,
  AddService,
  updateByOriginalPrice,
  getTherapistByTeamId,
  setAsRecommend,
  doctorServiceDelete,
  setAsMdt,
  setAsExecutive,
  saveCourseManageTeam,
  updatePatientShow
  // setAsMatron,
  // setAsLeader
} from "./api";
import {
  inquiry_config_detailByRefId,
  inquiry_config
} from "./api/medicalinfo";
import { imgBaseURL } from "@/utils/common.js";
export default {
  components: {},
  props: {},
  data() {
    // 手机号验证
    var validatorConsultFee = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请按要求输入咨询费"));
      } else if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error("请按要求输入咨询费"));
      } else {
        callback();
      }
    };
    // 身份证验证
    var validatorServiceTime = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请按要求输入服务时长"));
      } else if (!/^\d+$|^\d*\.\d+$/g.test(value)) {
        callback(new Error("请按要求输入服务时长"));
      } else {
        callback();
      }
    };
    return {
      breadList: [{ name: "机构组织" }, { name: "疗管团队" }],
      userId: "",
      tableData: [],
      rulesShare: {
        diseaseTypeName: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        publicityText: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 27个字符",
            trigger: "blur"
          }
        ],
        publicityPictureUrlRes: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ]
      },
      ossBaseUrl: process.env.VUE_APP_OSS_URL,
      dialogFormVisible: false,
      formShare: {
        publicityPictureUrlRes: "",
        publicityPictureUrl: ""
      },
      searchParams: {
        size: 10,
        current: 1
      },

      totalShare: 0,
      doctorTeamMemberList: [],
      teamServiceList: [],
      tableData1: [],
      formInline1: {
        size: 10,
        current: 1,
        keyword: "",
        total: 0
      },
      tableData2: [],
      formInline2: {
        size: 10,
        current: 1,
        name: "",
        total: 0
      },
      styleObj: {
        background: "#FAFAFA",
        fontWeight: "bold",
        color: "#333333",
        fontSize: "14px"
      },
      serviceListIf: false,
      sysListIf: false,
      addedParamData: {
        hasDoctor: false,
        name: "", //团队名称
        platformName: "",
        platformId: "", //归属平台
        teamType: "courseManage",
        departmentName: "",
        departmentId: "", //归属科室
        avatarImageUrl: "", //团体头像
        backgroundImageUrl: "", //背景图
        messagePushImageUrl: "", //消息推送图
        introduction: "", //团队介绍
        professional: "", //团队擅长
        caseMgrGroupName: "",
        caseMgrGroupId: "", //个案组ID,实际关联用户部门ID
        caseMgrGroup: {},
        id: "", //修改团队id
        mediaId: "", //微信推送素材ID
        hospitalId: "",
        hospitalName: "",
        openDepartmentName: "",
        openDepartmentId: ""
      },
      VUE_APP_WECHATBASE_URL: "",
      treeListHos: [],
      openDepartmentList: [],
      hospitalOptions: [], // 线下机构列表
      activeName1: 1,
      crolBtn: false,
      isEdit1: false,
      isEdit2: false,
      isEdit3: false,
      isEdit4: false,
      loadingNew: false,
      userPlatForm: local.get("userPlatForm"), //平台：platForm 机构：organization local.get('userPlatForm')
      SetKesDept: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false
      }, //设置联级选择器绑定的值
      setKesDept: {
        value: "id",
        label: "name",
        children: "children",
        disabled: "value",
        emitPath: false
      },
      information1: {
        realName: "", //姓名
        mobile: "", //手机号码
        idCard: "", //证件 号码
        // gender: '', //性别 1男2女0未知
        // birthday: '', //出生日期
        avatar: "", //医生照片
        photoUrlCopy: "", //用来展示图片
        note: "", //介绍
        departmentId: "", //科室ID
        departmentName: "",
        doctorType: "", //医护类型1.医生,2.护士,3.医技,4.药师6医辅
        hospitalId: "", //医院ID
        hospitalName: "",
        professional: "", //专业擅长
        titleId: "", //职称ID
        titleName: "",
        serviceScopeKm: "", //上门服务km
        provideNursingService: true
      },
      doctorCertificateSubmitDTO: {
        idCard: {
          back: "",
          front: "",
          watermarkBack: "",
          watermarkFront: ""
        },
        other: {
          watermarkFiles: "",
          files: []
        },
        practice: {
          watermarkFiles: "",
          files: [],
          number: "",
          obtainDate: ""
        },
        qualification: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: ""
        },
        title: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: ""
        },
        nameBadge: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: ""
        }
      },
      doctorTeam: {
        type: "0",
        id: "",
        doctorTeamName: "",
        name: "",
        departmentId: "",
        departmentName: "",
        platformId: "",
        platformName: "",
        caseMgrGroupId: "",
        caseMgrGroupName: ""
      },
      newSelectTteam: "",
      upavater: "", //需要上传的图片路径
      VUE_APP_BASE_URL: "",
      VUE_APP_BASE_URL1: "",
      isMdt: false,
      doctorTitleList: [],
      joinedTeamList: [],
      doctorTeamList: [], //其他团队
      platformOptions: [], //归属平台
      departmentList: [], //归属科室
      departmentList1: [], //归属科室
      caseMgrGroupList: [], //个案组列表
      hospitalList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入团队名称",
            trigger: "blur"
          },
          {
            min: 3,
            max: 25,
            message: "长度在 3 到 25 个字符",
            trigger: "blur"
          }
        ],

        caseMgrGroupId: [
          {
            required: true,
            message: "请选择个案组",
            trigger: "change"
          }
        ]
      },
      flagId: "",
      information2: {
        disabled: true,
        consultFee: "",
        serviceTime: "",
        describe: "",
        id: ""
      },
      rules1: {
        disabled: [
          {
            required: true,
            message: "请选择是否开启",
            trigger: "blur"
          }
        ],
        consultFee: [
          {
            required: true,
            // validate:validatorConsultFee,
            trigger: "blur",
            pattern: /^\d+(\.\d+)?$/,

            message: "请按要求输入咨询费"
          }
        ],
        serviceTime: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            // validate:validatorServiceTime,
            message: "请按要求输入服务时长",
            trigger: "blur"
          }
        ]
      },
      approved: false
    };
  },
  watch: {
    "addedParamData.hospitalId": {
      handler: function(newVal, oldVal) {
        // alert('898998')
        this.getTreeListHos(newVal);
      }
    }
  },
  computed: {},
  methods: {
    inputCusltFee(v) {},
    TeamAdministration2(scope, type) {
      let scopetItem = scope.row;
      if (type == "first") {
        if (scopetItem.doctorType == 1) {
          setAsLeader(scope.row.id).then(res => {
            this.$message.success("操作成功");
            // this.init();
            this.detailsHandel1({
              id: this.userId
            });
          });
        } else {
          setAsMatron(scope.row.id).then(res => {
            this.$message.success("操作成功");
            // this.init();
            this.detailsHandel1({
              id: this.userId
            });
          });
        }
      } else if (type == "mdt") {
        if (scope.row.mdt) {
          setAsExecutive(scope.row.id).then(res => {
            this.$message.success("操作成功");
            // this.init();
            this.detailsHandel1({
              id: this.userId
            });
          });
        } else {
          setAsMdt(scope.row.id).then(res => {
            this.$message.success("操作成功");
            // this.init();
            this.detailsHandel1({
              id: this.userId
            });
          });
        }
      } else {
        doctorMemberDelete({
          id: scope.row.id
        }).then(async res => {
          this.$message.success("删除成功！");
          // this.doctorTeamMemberList.splice(scope.$index, 1);
          // this.init();
          this.addedParamData.hospitalId = await this.detailsHandel1({
            id: this.userId
          });

          this.$nextTick(() => {
            this.formInlineGetPage();
          });
        });
      }
    },
    disabledChanged(e) {
      if (!e && !this.approved) {
        this.information2.disabled = true;
        this.$message.info("医生审核暂未通过，不可开通图文咨询");
        // this.$alert('医生审核暂未通过，不可开通图文咨询', '', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      }
    },
    TeamAdministration3(scope, type) {
      let scopetItem = scope.row;
      if (type == "first") {
        if (scopetItem.edit) {
          if (!scopetItem.price) {
            return this.$message.error("请输入价格");
          }
          if (!/^\d+(\.\d+)?$/.test(scopetItem.price)) {
            return this.$message.error("当前价格不合理, 请理智定价");
          }
          let price = Number(scopetItem.price);
          if (price < 0 || price >= 1000000) {
            return this.$message.error("当前价格不合理, 请理智定价");
          }
          if (String(scopetItem.price).split(".").length) {
            // if (String(scopetItem.price).split(".")[0].length > 6) {
            //   return this.$message.error("当前价格不合理, 请理智定价");
            // }
            if (
              String(scopetItem.price).split(".").length == 2 &&
              String(scopetItem.price).split(".")[1].length > 2
            ) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
          }
          if (scopetItem.originalPrice) {
            if (!/^\d+(\.\d+)?$/.test(scopetItem.originalPrice)) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
            if (
              Number(scopetItem.originalPrice) <= 0 ||
              Number(scopetItem.originalPrice) >= 1000000
            ) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
            if (String(scopetItem.originalPrice).split(".").length) {
              // if (String(scopetItem.originalPrice).split(".")[0].length > 6) {
              //   return this.$message.error("当前价格不合理, 请理智定价");
              // }
              if (
                String(scopetItem.originalPrice).split(".").length == 2 &&
                String(scopetItem.originalPrice).split(".")[1].length > 2
              ) {
                return this.$message.error("当前价格不合理, 请理智定价");
              }
            }

            if (Number(scopetItem.originalPrice) < Number(scopetItem.price)) {
              return this.$message.error("原价不可小于现价");
            }
          }
          if (!scopetItem.doctorTeamId) {
            AddService({
              doctorSchemeId: scopetItem.id,
              doctorTeamId: this.userId,
              name: scopetItem.name,
              originalPrice: scopetItem.originalPrice,
              price: scopetItem.price
            }).then(res => {
              this.$message.success("添加成功");
              this.formInlineGetPage1();

              this.getTeamService();
            });
            return;
          }
          updateByOriginalPrice({
            doctorSchemeId: scopetItem.doctorSchemeId,
            doctorTeamId: scopetItem.doctorTeamId,
            id: scopetItem.id,
            name: scopetItem.name,
            originalPrice: scopetItem.originalPrice,
            price: scopetItem.price
          }).then(res => {
            this.getTeamService({
              id: this.userId
            });

            this.$message.success("操作成功");
          });
          this.$set(scope.row, "edit", false);
          //
          // }).then(res=>{

          // })
        } else {
          this.$set(scope.row, "edit", true);
          scope.row.edit = true;
        }
        this.$forceUpdate();
      } else if (type == "second") {
        setAsRecommend({
          id: scopetItem.id,
          value: !scopetItem.recommend
        }).then(res => {
          this.getTeamService();

          this.$message.success("操作成功");
        });
      } else {
        // 给出弹框提示
        this.$confirm("是否移除此服务链?", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          center: true
        })
          .then(() => {
            doctorServiceDelete(scope.row.id).then(async res => {
              this.$message.success("删除成功");
              this.teamServiceList.splice(scope.$index, 1);

              await this.getTeamService();

              this.formInlineGetPage1();
            });
            // this.teamServiceList.splice(scope.$index,1);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    choisePerson2(data, index) {
      AdddoctorMember({
        doctorId: data.id,
        doctorTeamId: this.userId
      }).then(async res => {
        this.addedParamData.hospitalId = await this.detailsHandel1({
          id: this.userId
        });
        this.formInlineSubmit();

        this.$message.success("操作成功");
      });
    },
    choisePerson3(data, index) {
      // AddService({
      // 	doctorSchemeId:data.id,
      // 	doctorTeamId:this.userId,
      // 	name:data.name
      // }).then(res=>{
      for (let i = 0; i < this.teamServiceList.length; i++) {
        if (this.teamServiceList[i].edit === true) {
          return this.$message.info("请保存信息");
        }
      }
      this.teamServiceList.push({
        doctorSchemeId: data.id,
        ...data,
        originalPrice: "",
        price: "",

        edit: true
      });
      this.formInlineGetPage1();
      // })
    },
    // 详情弹框点编辑
    detailEdit() {
      this.isEdit1 = true;
      this.addedParamData.caseMgrGroup = this.addedParamData.caseMgrGroupName;
      this.addedParamData.hospitall = this.addedParamData.hospitalName;
    },
    choisePerson1(data, index) {
      this.teamServiceList.push({
        doctorSchemeId: data.id,
        ...data,
        edit: true
      });
      this.formInlineGetPage1();
    },
    serviceOpen() {
      this.serviceListIf = !this.serviceListIf;

      if (this.serviceListIf) {
        this.formInlineSubmit1();
      }
    },
    TeamAdministration(scope, type) {
      let scopetItem = scope.row;
      if (type == "first") {
        if (scopetItem.doctorType == 1) {
          for (let i = 0; i < this.doctorTeamMemberList.length; i++) {
            if (this.doctorTeamMemberList[i].leader) {
              this.$set(this.doctorTeamMemberList[i], "mdt", true);
            }
            if (i == scope.$index) {
              continue;
            }
            this.$set(this.doctorTeamMemberList[i], "leader", false);
          }
          this.$set(this.doctorTeamMemberList[scope.$index], "leader", true);
          this.$set(this.doctorTeamMemberList[scope.$index], "mdt", false);
          // 	this.doctorTeamMemberList[i].leader = false;
          // }
          // this.doctorTeamMemberList[scope.$index]['leader'] = !scopetItem.leader;
        } else if (scopetItem.doctorType == 2) {
          for (let i = 0; i < this.doctorTeamMemberList.length; i++) {
            if (i == scope.$index) {
              continue;
            }
            // this.doctorTeamMemberList[i].matron = false;
            this.$set(this.doctorTeamMemberList[i], "matron", false);
          }
          this.$set(
            this.doctorTeamMemberList[scope.$index],
            "matron",
            !scopetItem.matron
          );
          // this.doctorTeamMemberList[scope.$index]['matron'] = !scopetItem.matron;
        }
        this.$forceUpdate();
        return;
      } else if (type == "mdt") {
        this.$set(
          this.doctorTeamMemberList[scope.$index],
          "mdt",
          !this.doctorTeamMemberList[scope.$index].mdt
        );
      } else {
        // this.$confirm('此操作将删除该成员, 是否继续?', '提示', {
        // 	confirmButtonText: '确定',
        // 	cancelButtonText: '取消',
        // 	type: 'warning',
        // 	customClass: 'message-confirm-style'
        // }).then(() => {

        // this.tableData1.push(scope.row);
        this.doctorTeamMemberList.splice(scope.$index, 1);
        this.formInlineGetPage();
        // removeInfo(scopetItem.id).then((res) => {
        // 	if (res.code == 0) {
        // 		let index = this.informationDetails.memberList.findIndex((sub) => sub.id ==
        // 			scopetItem.id)
        // 		this.informationDetails.memberList.splice(index, 1)
        // 		this.init()
        // 	} else {
        // 		this.$message.error(`${res.message}`)
        // 	}
        // })
        // })
      }
    },
    caseMgrGroupChange(val) {
      this.addedParamData.caseMgrGroupName = "";
      for (var i = 0; i < this.caseMgrGroupList.length; i++) {
        if (this.caseMgrGroupList[i].id == val) {
          this.addedParamData.caseMgrGroupName = this.caseMgrGroupList[i].name;
        }
      }
    },
    TeamAdministration1(scope, type) {
      let scopetItem = scope.row;
      if (type == "first") {
        if (scopetItem.edit) {
          if (!scopetItem.price || !scopetItem.originalPrice) {
            return this.$message.error("请输入价格");
          }
          if (scopetItem.price < 0 || scopetItem.originalPrice < 0) {
            return this.$message.error("价格不能为负数");
          }
          if (String(scopetItem.price).split(".").length) {
            if (String(scopetItem.price).split(".")[0].length > 6) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
            if (
              String(scopetItem.price).split(".").length == 2 &&
              String(scopetItem.price).split(".")[1].length > 2
            ) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
          }
          if (String(scopetItem.originalPrice).split(".").length) {
            if (String(scopetItem.originalPrice).split(".")[0].length > 6) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
            if (
              String(scopetItem.originalPrice).split(".").length == 2 &&
              String(scopetItem.originalPrice).split(".")[1].length > 2
            ) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
          }
          if (scopetItem.price < scopetItem.originalPrice) {
            return this.$message.error("原价不可小于现价");
          }
          scope.row.edit = false;
        } else {
          scope.row.edit = true;
        }
        this.$forceUpdate();
      } else {
        this.teamServiceList.splice(scope.$index, 1);
        this.formInlineGetPage1();
      }
    },
    addPeopel() {
      this.sysListIf = !this.sysListIf;
      if (this.sysListIf) {
        this.formInlineSubmit();
      }
    },
    editSure() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (!this.formShare.publicityText.trim()) {
            return this.$message.info("请按要求填写");
          }
          updateCourseManageMedia(this.formShare)
            .then(result => {
              this.getCourseManageData();
              this.dialogFormVisible = false;
            })
            .catch(err => {});
        }
      });
    },
    onEditeClick(data) {
      getCourseManageMediaDetail({
        doctorTeamId: this.userId,
        diseaseTypeId: data.diseaseTypeId
      })
        .then(res => {
          if (!res.data.publicityText) {
            res.data.publicityText = "点击下方卡片，立即领取权益";
          }
          this.formShare = res.data;
          this.formShare.publicityPictureUrlRes =
            this.ossBaseUrl + res.data.publicityPictureUrl;
          this.dialogFormVisible = true;
        })
        .catch(err => {});
    },
    handleMessageResponseShare(res) {
      if (res.code !== 0) {
        return;
      }
      this.formShare.mediaId = res.data.media_id;
      this.formShare.publicityPictureUrl = res.data.ossUrl;
      this.formShare.publicityPictureUrlRes = `${this.ossBaseUrl}${res.data.ossUrl}`;
      this.$set(
        this.formShare,
        "publicityPictureUrlRes",
        `${this.ossBaseUrl}${res.data.ossUrl}`
      );
      this.$forceUpdate();
      return `${this.ossBaseUrl}${res.data.ossUrl}`;
    },
    handleMessagebeforeRemoveShare() {
      this.$nextTick(() => {
        this.formShare.publicityPictureUrl = "";
        this.$set(this.formShare, "publicityPictureUrlRes", "");
        this.$forceUpdate();
      });
    },
    getCourseManageData() {
      getCourseManageMediaList({
        doctorTeamId: this.userId
      }).then(res => {
        this.tableData = res.data;
      });
    },
    /**
     * @description: 首页查看详情
     * @param {*}
     * @return {*}
     */
    detailsHandel(scope, activeName) {
      this.activeName1 = 1;

      // return
      // this.userId = this.$route.query.id; //dectortemId
      getCourseManageTeam().then(res => {
        if (res.code == 0) {
          // addedParamData
          Object.keys(this.addedParamData).forEach(item => {
            this.addedParamData[item] = res.data[item];
            //TODO 拿到后端返回的半路经进行拼接展示

            if (["avatarImageUrl", "backgroundImageUrl"].includes(item)) {
              this.addedParamData[item] =
                res.data[item] && `${imgBaseURL}` + res.data[item];
            }
          });
          this.userId = res.data.id;
          this.approved = res.data.approved;
          if (res.data.id) {
            this.getTeamService();
            this.getCourseManageData();
          }

          // this.doctorTeamMemberList = res.data.memberList;
          // this.teamServiceList = res.data.teamServiceList;

          // this.getPlatformDepartmentListHandel({
          //   platformId: this.$route.query.platformId
          // });

          treeList({
            hospitalId: res.data.hospitalId,
            // 平台id
            companyId: this.$store.state.companyId,
            platformId: res.data.platformId,
            type: 2
          }).then(ress => {
            if (ress.code == 0) {
              ress.data.forEach(items => {
                if (items.id === res.data.caseMgrGroupId) {
                  this.addedParamData.caseMgrGroupName = items.reGroupName;
                  this.$set(this.addedParamData, "caseMgrGroup", items);
                }
              });
            }
          });
        }
      });

      // this.addHospitalChange();
    },
    /**
     * @description: 线下机构列表
     */
    getHospitalListHandel() {
      plateFormOn().then(res => {
        if (res.code == 0) {
          this.hospitalOptions = res.data;
        }
      });
    },

    submiAddCare6(ref) {
      this.$refs[ref].validate(async valid => {
        if (valid) {
          if (!this.information2.disabled) {
            var consultFee = Number(this.information2.consultFee);
            var serviceTime = Number(this.information2.serviceTime);
            if (consultFee <= 0 || consultFee > 9999.99) {
              return this.$message.error("请按要求填写咨询费");
            }
            if (serviceTime <= 0 || serviceTime > 24) {
              return this.$message.error("请按要求填写服务时长");
            }
            if (String(this.information2.serviceTime).split(".").length) {
              if (
                String(this.information2.serviceTime).split(".").length == 2 &&
                String(this.information2.serviceTime).split(".")[1].length > 1
              ) {
                return this.$message.error("请按要求填写服务时长");
              }
            }
            if (String(this.information2.consultFee).split(".").length) {
              if (
                String(this.information2.consultFee).split(".").length == 2 &&
                String(this.information2.consultFee).split(".")[1].length > 2
              ) {
                return this.$message.error("请按要求填写咨询费");
              }
            }
          }
          inquiry_config({
            refId: this.addedParamData.id,
            belong: 2,

            disabled: this.information2.disabled,
            consultFee: consultFee * 100,
            serviceTime: serviceTime,
            describe: this.information2.describe,
            id: this.information2.id
          }).then(res => {
            this.isEdit4 = false;
            inquiry_config_detailByRefId({
              refId: this.$route.query.id
            }).then(res => {
              this.information2.disabled = res.data.disabled;
              this.information2.consultFee = res.data.consultFee
                ? res.data.consultFee / 100
                : "";
              this.information2.serviceTime = res.data.serviceTime
                ? res.data.serviceTime
                : "";
              this.information2.describe = res.data.describe;
            });
          });
        } else {
        }
      });
    },
    getPlatformDepartmentListHandel(res) {
      //TODO 根据平台id得到科室id
      getPlatformDepartmentList({
        platformId: res.platformId
      }).then(res => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    detailsHandel1(scope, activeName) {
      return new Promise((resolve, reject) => {
        getCourseManageTeam().then(res => {
          if (res.code == 0) {
            // addedParamData
            Object.keys(this.addedParamData).forEach(item => {
              this.addedParamData[item] = res.data[item];
              //TODO 拿到后端返回的半路经进行拼接展示

              if (["avatarImageUrl", "backgroundImageUrl"].includes(item)) {
                this.addedParamData[item] =
                  res.data[item] && `${imgBaseURL}` + res.data[item];
              }
            });
            this.userId = res.data.id;
            this.approved = res.data.approved;
            if (this.userId) {
              this.getTeamService();
              this.getCourseManageData();
            }

            // this.doctorTeamMemberList = res.data.memberList;
            // this.teamServiceList = res.data.teamServiceList;

            treeList({
              hospitalId: res.data.hospitalId,
              // 平台id
              companyId: this.$store.state.companyId,
              platformId: res.data.platformId,
              type: 2
            }).then(ress => {
              if (ress.code == 0) {
                ress.data.forEach(items => {
                  if (items.id === res.data.caseMgrGroupId) {
                    this.addedParamData.caseMgrGroupName = items.reGroupName;
                    this.$set(this.addedParamData, "caseMgrGroup", items);
                  }
                });
              }
            });
            resolve(this.addedParamData.hospitalId);
          }

          // this.addHospitalChange();
        });
      });
    },
    getTeamService(id) {
      getTherapistByTeamId(this.userId).then(res => {
        this.$nextTick(() => {
          this.teamServiceList = res.data;
        });
      });
    },
    resetHandel1() {
      this.formInline1.keyword = "";

      this.formInlineSubmit();
    },
    resetHandel2() {
      this.formInline2.name = "";

      this.formInlineSubmit1();
    },
    handleCurrentChange1(val) {
      this.formInline2.current = val;
      this.formInlineGetPage1();
    },
    handleSizeChange1(val) {
      this.formInline2.size = val;
      this.formInlineGetPage1();
    },
    handleCurrentChange(val) {
      this.formInline1.current = val;
      this.formInlineGetPage();
    },
    handleSizeChange(val) {
      this.formInline1.size = val;
      this.formInlineGetPage();
    },

    formInlineSubmit1() {
      this.formInline2.current = 1;
      this.formInlineGetPage1();
    },
    formInlineGetPage1() {
      this.$nextTick(() => {
        getAllTherapistScheme({
          notDisplayList: this.teamServiceList.map(item => {
            return item.doctorSchemeId;
          }),

          ...this.formInline2
        }).then(res => {
          if (res.code == 0) {
            this.tableData2 = res.data.records;
            this.formInline2.total = res.data.total;
            return true;
          }
        });
      });
    },
    formInlineSubmit() {
      this.formInline1.current = 1;
      this.formInlineGetPage();
    },
    formInlineGetPage() {
      this.$nextTick(() => {
        doctorSearch({
          keywordSearchField: ["openDepartment"],
          notDisplayList: this.doctorTeamMemberList.map(item => {
            return item.doctorId;
          }),
          orderList: ["name"],
          searchPage: "doctorTeam",
          companyId: this.$store.state.companyId,
          platformId: this.$store.state.platformId,
          hospitalId:
            this.addedParamData.hospitalId || this.$store.state.hospitalId,
          ...this.formInline1
        }).then(res => {
          this.tableData1 = res.data.records;
          this.formInline1.total = res.data.total;
          return true;
        });
      });
    },
    closeaddCare() {
      this.$refs["addedParamData"].resetFields();
      this.addedParamData.avatarImageUrl = "";
      this.addedParamData.backgroundImageUrl = "";
      this.addedParamData.messagePushImageUrl = "";
      this.addedParamData.name = "";
      this.addedParamData.introduction = "";
      this.addedParamData.professional = "";
      this.addedParamData.caseMgrGroupId = "";
      this.addedParamData.caseMgrGroup = {};
      this.addedParamData.departmentId = "";
      this.addedParamData.platformId = "";
      this.addedParamData.hospitalId = "";
      this.addedParamData.hospitall = {};
      this.addedParamData.hospitalName = "";
      this.addedParamData.openDepartmentId = "";
      this.addedParamData.openDepartmentName = "";
      this.$nextTick(() => {
        this.$refs["addedParamData"].clearValidate();
      });
    },
    beforeUpLFnHos() {
      if (
        this.$store.state.userPlatForm === "platForm" &&
        !this.addedParamData.hospitalId
      ) {
        this.$message.info("请先选择线下机构");
        return false;
      }
      return true;
    },
    // 团队科室
    openDepartmentChange(val) {
      this.addedParamData.openDepartmentName = "";
      this.$nextTick(() => {
        this.addedParamData.openDepartmentName = this.$refs[
          "Mycascader"
        ].getCheckedNodes()[0].label;
      });
    },
    /**
     * @description: 团队图片上传
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     */
    handleResponse(response) {
      if (response.code == 0) {
        return (this.addedParamData.avatarImageUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data);
      }
    },
    /**
     * @description: 背景图片上传
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     */
    handleBackgroundResponse(response) {
      if (response.code == 0) {
        return (this.addedParamData.backgroundImageUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data);
      }
    },

    /**
     * @description: 消息推送上传 上传成功后会返回一个mediaID
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     */
    handleMessageResponse(response) {
      // if (!this.addedParamData.platformId) {
      //   // this.$message.info("请先选择归属平台");
      //   return false;
      // }
      // if(!this.addedParamData.platformId) return this.$message.error('请先选择归属平台')
      if (response.code == 0) {
        this.addedParamData.mediaId = response.data.media_id;
        return (this.addedParamData.messagePushImageUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data.ossUrl);
      } else {
        this.$message.error(response.message);
      }
    },
    handleTabClick(tab) {
      if (!this.userId) {
        return;
      }
      this.activeName1 = tab;
      if (tab == 2) {
        this.formInlineSubmit();
      } else if (tab == 3) {
        this.formInlineSubmit1();
      }
    },
    submiAddCare5(ref) {
      this.$refs["addedParamData"].validate(valid => {
        if (!this.addedParamData.avatarImageUrl) {
          return this.$message.error("请上传团队头像");
        }
        if (!this.addedParamData.backgroundImageUrl) {
          return this.$message.error("请上传团队背景图");
        }

        if (valid) {
          let obj = {
            ...this.addedParamData
          };
          Object.keys(obj).forEach(item => {
            if (["avatarImageUrl", "backgroundImageUrl"].includes(item)) {
              obj[item] = obj[item].substring(
                process.env.VUE_APP_OSS_URL.length
              );
            }
          });
          saveCourseManageTeam({
            ...obj,
            teamType: "courseManage"
          }).then(res => {
            this.isEdit1 = false;

            this.$message.success("操作成功");
            this.detailsHandel1({
              id: this.userId
            });
          });
        }
      });
    },
    /**
     *
     * 关闭新增医护弹回调
     */
    closeaddCare5() {
      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: ""
      };
      (this.doctorCertificateSubmitDTO.other = {
        files: [],
        fileList: [],
        watermarkFiles: ""
      }),
        (this.doctorCertificateSubmitDTO.practice = {
          files: [],
          fileList: [],
          number: "",
          obtainDate: "",
          watermarkFiles: ""
        }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          fileList: [],
          obtainDate: "",
          number: "",
          watermarkFiles: ""
        });
      this.doctorCertificateSubmitDTO.title = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
    },
    submiAddCare4() {
      let obj = {
        ...this.addedParamData
      };
      Object.keys(obj).forEach(item => {
        if (["avatarImageUrl", "backgroundImageUrl"].includes(item)) {
          obj[item] = obj[item].substring(process.env.VUE_APP_OSS_URL.length);
        }
      });
      doctorTeamCreate({
        ...obj,
        teamServiceList: this.teamServiceList,
        // doctorTeamMemberList: this.doctorTeamMemberList,
        caseMgrGroupId: this.addedParamData.caseMgrGroupId
      }).then(res => {
        this.dialogVisible = false;
        this.$message.success("操作成功");
        this.reset();
      });
    },
    submiAddCare3() {
      for (let i = 0; i < this.teamServiceList.length; i++) {
        if (this.teamServiceList[i].edit) {
          return this.$message.error("有信息未保存");
        }
      }
      this.submiAddCare4();
    },

    handleMessageResponse2(response) {
      if (response.code == 0) {
        return (this.upavater = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },

    handleMessage3beforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.idCard.watermarkFiles.split(',').length - 1 < index){
      //  return;
      // }
      // let str = this.doctorCertificateSubmitDTO.idCard.watermarkFront.split(',').splice(index,1).join(',');
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = "";
    },
    handleMessageResponse4(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkFront = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.front = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },
    handleMessage4beforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.idCard.watermarkFiles.split(',').length - 1 < index){
      //  return;
      // }
      // let str = this.doctorCertificateSubmitDTO.idCard.watermarkFront.split(',').splice(index,1).join(',');
      this.doctorCertificateSubmitDTO.idCard.watermarkFront = "";
    },
    /**
     * @description: 上传资格证图片
     * @event:
     * @param {*}
     * @return {*}
     */
    certificateQualificationResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        let a = `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`;
        if (
          this.doctorCertificateSubmitDTO.qualification.watermarkFiles == ""
        ) {
          this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.qualification.watermarkFiles = arr.join(
            ","
          );
        }

        return this.doctorCertificateSubmitDTO.qualification.files.push(a);
      }
    },
    certificateQualificationbeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(
        ","
      );
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.qualification.watermarkFiles = str.join(
        ","
      );
    },
    /**
     * @description: 执业证上传
     * @event:
     * @param {*}
     * @return {*}
     */
    practiceUploadImage(response) {
      if (response.code == 0) {
        // setTimeout(() => {

        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.practice.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.practice.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.practice.watermarkFiles = arr.join(
            ","
          );
        }
        return this.doctorCertificateSubmitDTO.practice.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    practicebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(
        ","
      );
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.practice.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.practice.watermarkFiles = str;
    },
    /**
     * @description: 职称证上传
     * @event:
     * @param {*} e
     * @return {*}
     */
    certificatePracticeResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.title.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.title.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.title.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.title.watermarkFiles = arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.title.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificatePracticebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.title.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.title.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.title.watermarkFiles = str;
    },
    // 胸牌
    certificateNameBadgeResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles = arr.join(
            ","
          );
        }
        return this.doctorCertificateSubmitDTO.nameBadge.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificateNameBadgebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles.split(
        ","
      );
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.title.watermarkFiles = str;
    },
    /**
     * @description: 其他相关证书上传
     * @event:
     * @param {*} e
     * @return {*}
     */
    certificateOtherUplod(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.other.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.other.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.other.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.other.watermarkFiles = arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.other.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificateOtherbeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.other.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.other.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }

      let str = this.doctorCertificateSubmitDTO.other.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.other.watermarkFiles = str.join(",");
    },
    radioChangeGrounp(e) {
      // this.doctorTeamId = '';
      // if(e == false){
      // this.departmentList1 = [];//归属科室
      // this.caseMgrGroupList = [];//个案组列表
      this.doctorTeam.name = "";
      this.doctorTeam.id = "";
      this.doctorTeam.platformId = "";
      this.doctorTeam.departmentId = "";
      this.doctorTeam.caseMgrGroupId = "";
      this.doctorTeam.openDepartmentId = "";
    },
    doctorTeamChange(val) {
      this.doctorTeam.doctorTeamName = "";
      for (var i = 0; i < this.doctorTeamList.length; i++) {
        if (this.doctorTeamList[i].id == val) {
          this.doctorTeam.doctorTeamName = this.doctorTeamList[i].name;
        }
      }
    },
    departmentTeamChange() {
      this.doctorTeam.departmentName = "";
      this.$nextTick(() => {
        this.doctorTeam.departmentName = this.$refs[
          "Mycascader1"
        ].getCheckedNodes()[0].label;
      });
    },

    PreviousStep() {
      // this.flagId = this.information1.hospitalId;
      this.activeName1 -= 1;
    },
    hospitalChange(val) {
      this.hospitalId = val;
      if (this.information1.doctorType == 2) {
        // getHaveNursingService(val).then(res=>{
        // 	this.haveService = res.data
        // })
      }
      if (this.userPlatForm == "platForm") {
        this.getTreeList(
          this.userPlatForm == "platForm"
            ? this.information1.hospitalId
            : local.get("hospitalId")
        );
        if (this.information1.hospitalId) {
          getPlatformOpenDepartmentList({
            hospitalId: this.information1.hospitalId
          }).then(res => {
            if (res.code == 0) {
              this.departmentList1 = res.data;
            }
          });
        }
      } else {
        for (var i = 0; i < this.platformOptions.length; i++) {
          if (this.platformOptions[i].id == this.information1.hospitalId) {
            this.doctorTeam.platformName = this.platformOptions[i].name;
          }
        }
      }

      this.hospitalList.forEach(item => {
        if (item.id == val) {
          this.doctorTeam.hospitalId = item.id;
          this.doctorTeam.hospitalName = item.name;
        }
      });

      this.information1.hospitalName = "";
      for (var i = 0; i < this.hospitalList.length; i++) {
        if (
          this.hospitalList[i].id == val ||
          this.hospitalList[i].id == this.information1.hospitalId
        ) {
          this.information1.hospitalName = this.hospitalList[i].name;
        }
      }
      this.apiDoctorTeamSearchinit(val);
      if (this.dialogVisible) {
        this.information1.departmentId = "";
      }

      api_department({
        hospitalId: val
      }).then(res => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    departmentChange(val) {
      this.information1.departmentName = "";
      if (!this.$refs["Mycascader"].getCheckedNodes().length) {
        return;
      }
      this.$nextTick(() => {
        this.information1.departmentName = this.$refs[
          "Mycascader"
        ].getCheckedNodes()[0].label;
      });
    },
    apiDoctorTeamSearchinit(id) {
      let val = id ? id : null;
      api_doctor_team({
        disabled: false,
        hospitalId: val
      }).then(res => {
        this.doctorTeamList = res.data;
      });
    },
    getTreeList(id) {
      treeList({
        type: 2,
        hospitalId: this.hospitalId
      }).then(res => {
        if (res.code == 0) {
          this.caseMgrGroupList = res.data;
        }
      });
    },
    getPlatformListHandel() {
      // {disabled:false}
      getPlatformList({
        disabled: false
      }).then(res => {
        if (res.code == 0) {
          this.platformOptions = res.data;
        }
      });
    },
    submiAddCare1(ref) {
      this.$refs["addedParamData"].validate(valid => {
        if (valid) {
          if (!this.addedParamData.avatarImageUrl)
            return this.$message.error("请上传团体头像");
          // if (!this.addedParamData.backgroundImageUrl) return this.$message.error('请上传团体背景图')
          // if (!this.addedParamData.messagePushImageUrl) return this.$message.error('请上传消息推送群');

          this.activeName1 += 1;
        }
      });
    },
    submiAddCare2() {
      if (this.doctorTeamMemberList.length == 0) {
        this.$message.info("请至少选择一位成员");
        return;
      }
      let Continue = false;
      for (let i = 0; i < this.doctorTeamMemberList.length; i++) {
        if (
          this.doctorTeamMemberList[i].doctorType == 1 &&
          this.doctorTeamMemberList[i].leader
        ) {
          Continue = true;
        }
        if (
          this.doctorTeamMemberList[i].doctorType == 2 &&
          this.doctorTeamMemberList[i].matron
        ) {
          Continue = true;
        }
      }
      if (!Continue) {
        this.$message.info("请设置领衔医生或者护士长");
        return;
      }
      this.activeName1 += 1;
    },
    closeaddCare2() {
      if (this.information1.doctorType != 4) {
        this.newSelectTteam = "";
        this.doctorTeam.type = "";
        this.isMdt = false;
        this.doctorTeam.id = "";
        this.doctorTeam.doctorTeamName = "";
        this.doctorTeam.name = "";
        this.doctorTeam.departmentId = "";
        this.doctorTeam.departmentName = "";
        this.doctorTeam.platformId = "";
        this.doctorTeam.platformName = "";
        this.doctorTeam.caseMgrGroupName = "";
      }
    },
    closeaddCare3() {
      // if(this.information1.doctortype !== 4){
      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: ""
      };
      (this.doctorCertificateSubmitDTO.other = {
        files: [],
        watermarkFiles: ""
      }),
        (this.doctorCertificateSubmitDTO.practice = {
          files: [],
          number: "",
          obtainDate: "",
          watermarkFiles: ""
        }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          obtainDate: "",
          number: "",
          watermarkFiles: ""
        });
      this.doctorCertificateSubmitDTO.title = {
        files: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
    },
    getPlatformListInit() {
      getPlatformList({}).then(res => {
        if (res.code == 0) {
          this.platformList.hospitalList = res.data;
        }
      });
    },
    closeaddCare1() {
      this.information1 = this.$options.data().information1;
      this.upavater = "";
      this.doctorTitleList = [];
    },
    redioChange() {
      this.information1.serviceScopeKm = "";
    },
    closeaddCare2() {
      // if(this.information1.doctorType != 4){
      this.newSelectTteam = "";
      this.doctorTeam.type = "";
      this.isMdt = false;
      this.doctorTeam.id = "";
      this.doctorTeam.doctorTeamName = "";
      this.doctorTeam.name = "";
      this.doctorTeam.departmentId = "";
      this.doctorTeam.departmentName = "";
      this.doctorTeam.platformId = "";
      this.doctorTeam.platformName = "";
      this.doctorTeam.caseMgrGroupName = "";
      // }
    },
    doctorTitleChange(v) {
      this.information1.titleName = "";
      for (var i = 0; i < this.doctorTitleList.length; i++) {
        if (this.doctorTitleList[i].id == v) {
          this.information1.titleName = this.doctorTitleList[i].name;
        }
      }
    },
    selectDoctorType(e) {
      this.getDoctorTitle(e);
      // if (e == 2) {
      this.information1.serviceScopeKm = "";
      (this.information1.note = ""), //介绍
        (this.information1.departmentId = ""); //科室ID
      this.information1.departmentName = ""; //科室ID
      this.information1.titleId = ""; //科室ID
      // this.information1.titleName = ""; //科室ID
      this.information1.professional = ""; //专业擅长
      this.information1.hospitalId = ""; //医院ID
      this.information1.hospitalName = "";
      this.information1.serviceScopeKm = ""; //上门服务km
      if (e == 2) {
        this.information1.provideNursingService = true;
      }
      // this.$refs['addForm'].clearValidate();
      this.closeaddCare2();
      this.closeaddCare3();
      // }
    },
    getDoctorTitle(t) {
      doctor_title(t).then(res => {
        if (res.code == 0) {
          this.doctorTitleList = res.data;
        }
      });
    },
    handleMessageResponse1(response) {
      if (response.code == 0) {
        return (this.information.photoUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data);
      }
    },

    handleMessageResponse2(response) {
      if (response.code == 0) {
        return (this.upavater = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },
    handleMessageResponse3(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },

    getdetail(data) {
      const machiningFiles = (filesName, type) => {
        if (type)
          return filesName
            .split(",")
            .map(sub => `${process.env.VUE_APP_OSS_URL}` + sub);
        else return filesName.split(",").toString();
      };

      getDoctor(data ? data : this.$route.query.id).then(res => {
        this.$nextTick(() => {
          // DOM 更新了
          // this.$refs["addForm"].clearValidate()

          if (res.data.hospitalId) this.hospitalChange(res.data.hospitalId);
          this.upavater = !!res.data.photoUrl
            ? process.env.VUE_APP_OSS_URL + res.data.photoUrl
            : "";
          this.hospitalObj = res.data.hospital;
          this.information1.mobile = res.data.phone;
          this.information1.realName = res.data.name; //姓名
          (this.information1.idCard = res.data.idCardNumber), //证件 号码
            (this.information1.id = res.data.id);
          // this.information1.photoUrlCopy = "";//用来展示图片
          (this.information1.note = res.data.introduction), //介绍
            (this.information1.departmentId = res.data.departmentId); //科室ID
          this.information1.departmentName = res.data.departmentName;
          this.information1.doctorType = res.data.doctorType; //医护类型1.医生,2.护士,3.医技,4.药师
          this.getDoctorTitle(res.data.doctorType);
          this.information1.hospitalId = res.data.hospitalId; //医院ID
          this.information1.hospitalName = res.data.hospitalName;
          this.information1.professional = res.data.professional; //专业擅长
          this.information1.titleId = res.data.titleId; //职称ID
          this.information1.titleName = res.data.titleName;
          this.information1.serviceScopeKm = res.data.serviceScopeKm; //上门服务km
          this.information1.provideNursingService =
            res.data.provideNursingService;
          // this.information1.disabled = res.data.disabled;
          // this.information1.idCardType = res.data.idCardType
          this.joinedTeamList = res.data.joinedTeamList
            ? res.data.joinedTeamList
            : [];

          if (res.data.certificateIdCard != null) {
            this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.back}`;
            this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.watermarkBack}`;
            this.doctorCertificateSubmitDTO.idCard.front = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.front}`;
            this.doctorCertificateSubmitDTO.idCard.watermarkFront = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.watermarkFront}`;
          }
          //拷贝资格证信息
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
              res.data.certificateQualification.watermarkFiles;
            this.doctorCertificateSubmitDTO.qualification.files = machiningFiles(
              res.data.certificateQualification.files,
              1
            );
            this.doctorCertificateSubmitDTO.qualification.fileList = res.data.certificateQualification.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.number
          ) {
            this.doctorCertificateSubmitDTO.qualification.number =
              res.data.certificateQualification.number;
          }
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.getDate
          ) {
            this.doctorCertificateSubmitDTO.qualification.obtainDate =
              res.data.certificateQualification.getDate;
          }
          //拷贝执业证信息
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.practice.watermarkFiles =
              res.data.certificatePractice.watermarkFiles;
            this.doctorCertificateSubmitDTO.practice.files = machiningFiles(
              res.data.certificatePractice.files,
              1
            );
            this.doctorCertificateSubmitDTO.practice.fileList = res.data.certificatePractice.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.number
          ) {
            this.doctorCertificateSubmitDTO.practice.number =
              res.data.certificatePractice.number;
          }
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.getDate
          ) {
            this.doctorCertificateSubmitDTO.practice.obtainDate =
              res.data.certificatePractice.getDate;
          }
          //拷贝职业证信息
          if (
            res.data.certificateTitle != null &&
            res.data.certificateTitle.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.title.watermarkFiles =
              res.data.certificateTitle.watermarkFiles;
            this.doctorCertificateSubmitDTO.title.files = machiningFiles(
              res.data.certificateTitle.files,
              1
            );
            this.doctorCertificateSubmitDTO.title.fileList = res.data.certificateTitle.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }
          //拷贝胸牌
          if (
            res.data.certificateNameBadge != null &&
            res.data.certificateNameBadge.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
              res.data.certificateNameBadge.watermarkFiles;
            this.doctorCertificateSubmitDTO.nameBadge.files = machiningFiles(
              res.data.certificateNameBadge.files,
              1
            );
            this.doctorCertificateSubmitDTO.nameBadge.fileList = res.data.certificateNameBadge.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }

          //拷贝其他相关
          if (
            res.data.certificateOther != null &&
            res.data.certificateOther.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.other.watermarkFiles =
              res.data.certificateOther.watermarkFiles;
            this.doctorCertificateSubmitDTO.other.files = machiningFiles(
              res.data.certificateOther.files,
              1
            );
            this.doctorCertificateSubmitDTO.other.fileList = res.data.certificateOther.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }

          // if (res.code == 0) {
          //   this.getListByDoctorIdInit();
          //   //有实体平台的时候，需要根据hospitalId进行查询下级实体科室列表
          // }
        });
      });
    },
    /**
     * @description: 选择线下机构下的个案
     * @param {*} event
     * @return {*}
     */

    addHospitalChange(event = {}) {
      this.addedParamData.openDepartmentId = "";
      this.addedParamData.messagePushImageUrl = "";
      this.addedParamData.caseMgrGroupId = "";
      this.addedParamData.caseMgrGroup = {};
      this.treeListHos = [];
      // this.selectOnCallBack(event)
      this.openDepartmentList = [];
      this.addedParamData.hospitalId = event.id || this.$store.state.hospitalId;
      this.addedParamData.hospitalName =
        event.name || this.$store.state.orgName;
      this.addedParamData.platformId =
        event.platformId || this.$store.state.platformId;
      this.$set(
        this.addedParamData,
        "companyId",
        event.companyId || this.$store.state.companyId
      );
      getHospitalDepartmentList({
        hospitalId: event.id || this.$store.state.hospitalId
      }).then(res => {
        if (res.code == 0) {
          this.openDepartmentList = res.data;
        }
      });
      this.getTreeListHos(event.id || this.$store.state.hospitalId);
    },
    getTreeListHos() {
      treeList({
        hospitalId:
          this.addedParamData.hospitalId || this.$store.state.hospitalId,
        // 平台id
        companyId: this.$store.state.companyId,
        platformId:
          this.addedParamData.platformId || this.$store.state.platformId,
        type: 2
      }).then(res => {
        if (res.code == 0) {
          this.treeListHos = res.data;
        }
      });
    },
    /**
     * @description: 获取相应医院下的科室
     * @param {*} event
     * @param {*} type
     * @return {*}
     */
    selectOnCallBack(event, type) {
      openeDpartment({
        hospitalId: event
      }).then(res => {
        if (res.code == 0) {
          if (type == "selectOnChangeOne") {
            this.departmentListOne = res.data;
          } else {
            this.departmentList = res.data;
          }
        }
      });
    },
    /**
     * @description: 线下机构列表
     */
    getHospitalListHandel() {
      plateFormOn().then(res => {
        if (res.code == 0) {
          this.hospitalOptions = res.data;
        }
      });
    },
    /**
     * @description: 根据医生ID查询平台列表
     * @param {*}
     * @return {*}
     */
    // getListByDoctorIdInit() {
    //   getListByDoctorId(this.information1.id).then(res => {
    //     if (res.code == 0) {
    //       this.platformList.tableData = res.data;
    //     }
    //   });
    // }
    // 前端展示
    async showFront(row) {
      // 前端展示
      let { code, data } = await updatePatientShow({
        id: row.id,
        show: !row.patientShow
      });
      if (code === 0) {
        // 获取列表接口
        this.getTeamService();
        this.$message.success("操作成功");
      }
    }
  },

  beforeDestroy() {
    // local.remove("doctorChainId");
  },
  created() {
    this.VUE_APP_BASE_URL = "/api/dsicm-contact-platform/feign/file/upload";
    this.VUE_APP_BASE_URL1 =
      "/api/dsicm-contact-platform/feign/file/uploadWatermark";
    this.VUE_APP_WECHATBASE_URL =
      "/api/dsicm-contact-platform/feign/file/wechat/upload";

    // this.getDoctorTitle(); //获取职称段位
    // this.getPlatformListInit()
    this.detailsHandel();
    this.getTreeListHos();
    // this.getPlatformListHandel();
    // if (this.$store.state.userPlatForm === "platForm") {
    //   // 平台--线下机构接口列表
    //   this.getHospitalListHandel();
    // } else {
    //   this.addHospitalChange(); // 首次进入获取团队科室列表
    // }
    // this.$nextTick(()=>{
    //   if(this.$route.query.type){
    //     this.handleTabClick(this.$route.query.type)
    //   }
    // })
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/deep/.el-select {
  width: 100%;
}

/deep/.el-cascader {
  width: 100%;
}

.headerCom {
  .top-tabs {
    div {
      cursor: pointer;
      vertical-align: top;
      display: inline-block;
      line-height: 26px;
    }

    .tabs-cliked {
      color: #1a7bfc;

      span {
        padding-bottom: 4px;
        border-bottom: 2px solid #1a7bfc;
      }
    }

    div:nth-of-type(2) {
      margin-left: 64px;
    }

    div:nth-of-type(3) {
      margin-left: 64px;
    }

    div:last-of-type {
      min-width: 275px;
      margin-left: 64px;
    }
  }
}

.content {
  margin: 0;
  padding: 10px 20px;
  background: #fff;

  .team-item {
    margin-left: 40px;
    margin-bottom: 20px;

    h3 {
      margin-bottom: 30px;
      font-size: 14px;
    }

    ul {
      display: flex;
      width: 100%;

      li {
        flex: 1;
        font-size: 12px;
        display: flex;

        label {
          white-space: nowrap;
          margin-right: 20px;
        }
      }
    }
  }

  .tip-zhengshu {
    color: #999999;
  }

  .label-circle {
    display: flex;
    margin-bottom: 10px;
    height: 25px;
    align-items: center;
    width: 128px;
    flex-flow: row-reverse;

    span:nth-of-type(2) {
      margin-right: 10px;
      width: 6px;
      height: 6px;
      background: #d0e4ff;
      border-radius: 50%;
    }
  }

  .line-div {
    margin: 0px 0 15px;
    display: flex;
    align-items: center;

    span:nth-of-type(1) {
      display: inline-block;
      width: 4px;
      height: 14px;
      background: #1a7bfc;
      margin-right: 10px;
      vertical-align: middle;
    }

    span:nth-of-type(2) {
      font-weight: bold;
      font-size: 14px;
      vertical-align: middle;
      flex: 1;
    }
  }

  .dialog-footer {
    padding: 20px;
    display: block;
  }

  .dialog-footer {
    display: block;
    margin-top: 10px;
    padding: 5px 0 10px;
    text-align: center;

    .dialog-btn {
      width: 110px;
      height: 32px;
    }
  }
}

.no-div {
  margin: 125px auto 20px;
  text-align: center;

  p {
    margin-top: 20px;
  }
}

.list-two {
  margin-bottom: 12px;
}

.pagenation {
  display: flex;
  justify-content: flex-end;
}
</style>
